import { ButtonPiece } from "./ButtonPiece";

interface EmptyStatePieceProps {
  title: string;
  message: string;
  actionLabel?: string;
  actionTo?: string;
}

export const EmptyStatePiece = ({
  title,
  message,
  actionLabel,
  actionTo,
}: EmptyStatePieceProps) => (
  <div className="panel-surface mx-auto flex max-w-2xl flex-col items-center gap-4 p-8 text-center sm:p-12">
    <span className="eyebrow-label">CMJ Cinema</span>
    <h2 className="font-display text-4xl uppercase text-white">
      {title}
    </h2>
    <p className="max-w-xl text-base leading-7 text-cmj-mist">{message}</p>
    {actionLabel && actionTo ? (
      <ButtonPiece appearance="secondary" to={actionTo}>
        {actionLabel}
      </ButtonPiece>
    ) : null}
  </div>
);
